import { render, staticRenderFns } from "./Purchase_item.vue?vue&type=template&id=62778236&scoped=true&"
import script from "./Purchase_item.vue?vue&type=script&lang=js&"
export * from "./Purchase_item.vue?vue&type=script&lang=js&"
import style0 from "./Purchase_item.vue?vue&type=style&index=0&id=62778236&prod&lang=css&"
import style1 from "./Purchase_item.vue?vue&type=style&index=1&id=62778236&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62778236",
  null
  
)

export default component.exports